var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { ClickAwayListener, Grow, Popper } from '@material-ui/core';
import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { primary } from '../../Styles/Colours';
import { Button, ButtonGroupStyle, ButtonMode, ButtonSize, ButtonVariant } from '../Button';
import { ArrowDropDownIcon } from '../Icons';
import styles from './MenuButton.module.css';
export var MenuItem = function (props) {
    var _a;
    var containerClasses = classNames(styles.menuItem, (_a = {},
        _a[styles.menuItemDisabled] = !!props.disabled,
        _a));
    return (React.createElement("div", { className: containerClasses, onClick: function (e) {
            if (props.onClick)
                props.onClick(e);
        } },
        React.createElement("span", { className: styles.menuItemTitle, "data-test-id": props.testId },
            !!props.startIcon && React.createElement("span", { className: styles.icon }, props.startIcon),
            props.title)));
};
export var MenuDivider = function () { return React.createElement("div", { className: styles.menuDivider }); };
export var MenuButton = function (props) {
    var label = props.label, buttonProps = __rest(props, ["label"]);
    var buttonRef = useRef(null);
    var _a = __read(useState(false), 2), menuOpen = _a[0], setMenuOpen = _a[1];
    var closeMenu = function () {
        setMenuOpen(false);
    };
    var editButtonClick = function () { return setMenuOpen(!menuOpen); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, __assign({}, buttonProps, { ref: buttonRef, testId: props.testId, size: ButtonSize.small, mode: ButtonMode.border, variant: ButtonVariant.light, buttonGroup: ButtonGroupStyle.Left, endIcon: React.createElement(ArrowDropDownIcon, { noPadding: true, size: '20', color: primary }), onClick: editButtonClick }), label),
        React.createElement(Popper, { open: menuOpen, anchorEl: buttonRef.current, placement: 'bottom-end', className: styles.popper, modifiers: {
                flip: {
                    enabled: true
                },
                preventOverflow: {
                    enabled: true,
                    boundariesElement: 'scrollParent'
                }
            } },
            React.createElement(ClickAwayListener, { onClickAway: closeMenu },
                React.createElement(Grow, { in: true, style: { transformOrigin: 'top right' } },
                    React.createElement("div", { className: styles.addMenu }, props.children({
                        closeMenu: closeMenu
                    })))))));
};
